import { useState } from 'react';
import { transform400Message } from './helpers';
import { ExtendedAxiosError } from './types';

export function useBadRequestOrConflictError() {
  const [_errors, _setErrors] = useState<string[]>([]);

  const cleanErrors = () => _setErrors([]);

  const is400or409Error = (error: ExtendedAxiosError) =>
    error.response?.status == 400 || error.response?.status == 409;

  const pushErrors = (errors: string[]) => {
    // push plain errors to toast
    _setErrors(errors);
  };

  const mapErrors = (error: ExtendedAxiosError): string[] => {
    const message = transform400Message(error.response?.data.message ?? []);
    if (Array.isArray(message)) {
      return message;
    }

    // TODO: the way we send error messages must be changes and standardized
    const splitMessage = message.split(';');
    if (splitMessage.length === 1) return [splitMessage[0]];

    return splitMessage.reduce((acc: string[], se: string) => {
      const [label, message] = se.split(':');
      acc.push(`${label}: ${message || ''}`);
      return acc;
    }, []);
  };

  const setErrors = (error: ExtendedAxiosError) => {
    if (!is400or409Error(error)) return;
    const errors = mapErrors(error);
    pushErrors(errors);
  };

  return { setErrors, cleanErrors, errors: _errors };
}
